import { render, staticRenderFns } from "./shipment-open-report-table.vue?vue&type=template&id=259aaa20&scoped=true"
import script from "./shipment-open-report-table.vue?vue&type=script&lang=js"
export * from "./shipment-open-report-table.vue?vue&type=script&lang=js"
import style0 from "./shipment-open-report-table.vue?vue&type=style&index=0&id=259aaa20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259aaa20",
  null
  
)

export default component.exports